import React from 'react';
import "./Aboutus.css";
import Header from '../../components/header/header';

const Aboutus = () => {
  return (
    <div className="aboutus-container">
        <Header />
      {/* <h2>About Us</h2> */}
      <p>
        At <strong>Priya Pratap Makeup Studio</strong>, beauty is more than just makeup – 
        it’s about enhancing your natural features and making you feel confident, 
        radiant, and unforgettable. Based in <strong>Bijnor, Uttar Pradesh</strong>, 
        we specialize in creating stunning looks tailored to your personality, 
        occasion, and style.
      </p>
      <p>
        With expertise in <strong>bridal, editorial, party, and natural glam makeup</strong>, 
        we bring artistry and precision to every brushstroke. Whether it’s your wedding day, 
        a special celebration, or a professional shoot, our goal is to make you look 
        and feel your absolute best.
      </p>
      <p>
        We use premium products, the latest techniques, and a personalized approach to 
        ensure a flawless, long-lasting finish that photographs beautifully and feels 
        comfortable all day.
      </p>
      <p>
        At Priya Pratap Makeup Studio, every face is a canvas and every client is our muse. 
        Let us bring your dream look to life – because you deserve to shine on your special day.
      </p>

      {/* Google Map Embed */}
      <div className="map-container">
        <iframe
          title="Google Map Location"
          src="https://www.google.com/maps?q=29.381250,78.137960&hl=en&z=14&output=embed"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Aboutus;
